import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "antd";
import LoaderSpin from "../Common/LoaderSpin";
import { getAccessToken } from "../../services/authService";

// Admin invitation link. Reached only when signed in (ProtectedRoute sends visitors to
// sign in or register first). The server checks the link and the verified email; the
// Admin role is only granted by the server when Accept is pressed.
const call = async (path, method = "GET") => {
  const token = getAccessToken();
  const res = await fetch(`${process.env.REACT_APP_DEV_API}${path}`, { method, headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json?.message || "Something went wrong.");
  return json.data || {};
};

const AcceptAdminInvite = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true });
  const [accepting, setAccepting] = useState(false);

  useEffect(() => {
    call(`/admin-invites/${encodeURIComponent(token)}`)
      .then((d) => setState({ invite: d }))
      .catch((e) => setState({ error: e.message }));
  }, [token]);

  const accept = async () => {
    setAccepting(true);
    try {
      await call(`/admin-invites/${encodeURIComponent(token)}/accept`, "POST");
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      localStorage.setItem("user", JSON.stringify({ ...user, role: "ADMIN", staffActive: true }));
      setState({ done: true });
    } catch (e) { setState({ error: e.message }); } finally { setAccepting(false); }
  };

  return (
    <div className="min-h-full flex justify-center items-center p-6">
      <div className="w-full max-w-[460px] bg-white border rounded-xl p-8 text-center" style={{ borderColor: "#E4E4E4" }}>
        <h1 className="text-[22px] font-bold mb-3">Morphosys Admin Invitation</h1>
        {state.loading && <LoaderSpin size={32} loading />}
        {state.error && <>
          <p className="text-[15px] mb-6" role="alert">{state.error}</p>
          <Button onClick={() => navigate("/home", { replace: true })}>Go to Dashboard</Button>
        </>}
        {state.invite && <>
          <p className="text-[15px] mb-2">You've been invited to become a Morphosys Administrator.</p>
          <p className="text-[13px] mb-6" style={{ color: "#868686" }}>Invitation for {state.invite.email}. Expires {new Date(state.invite.expiresAt).toLocaleDateString()}.</p>
          <Button type="primary" size="large" loading={accepting} onClick={accept} style={{ background: "#0099FF" }}>Accept invitation</Button>
        </>}
        {state.done && <>
          <p className="text-[15px] mb-6">Invitation accepted. You now have Admin access.</p>
          <Button type="primary" size="large" onClick={() => navigate("/admin", { replace: true })} style={{ background: "#0099FF" }}>Open Admin Dashboard</Button>
        </>}
      </div>
    </div>
  );
};

export default AcceptAdminInvite;
